import { Form } from 'antd';
import { FormField } from '../types';
import { useChangePasswordStore, useUpdateData } from '../hooks';
import { ChangePassword } from '../types/auth.model';
import ModalForm from './ui/ModalForm';
import React from 'react';

const ResetPassword = ({
  visible,
  onClose,
}: {
  visible: boolean;
  onClose: () => void;
}) => {
  const [form] = Form.useForm();
  const changePasswordStore = useChangePasswordStore();

  const fields: FormField[] = [
    {
      name: 'oldPassword',
      label: 'Old Password',
      type: 'password',
      rules: [{ required: true, message: 'Please enter old password' }],
    },
    {
      name: 'newPassword',
      label: 'New Password',
      type: 'password',
      rules: [
        { required: true, message: 'Please enter password' },
        { min: 6, message: 'Password must be at least 6 characters' }, // Minimum length validation
      ],
    },
    {
      name: 'confirmPassword',
      label: 'Confirm Password',
      type: 'confirmPassword',
    },
  ];

  const handleClose = () => {
    form.resetFields();
    onClose();
  };

  const { mutate: mutateUpdate } = useUpdateData<ChangePassword>(
    '/users/change-password',
  );

  const onFinish = (values: {
    oldPassword: string;
    newPassword: string;
    confirmPassword: string;
  }) => {
    const jsonData = {
      oldPassword: values.oldPassword,
      newPassword: values.newPassword,
      confirmPassword: values.confirmPassword,
    };
    mutateUpdate({ id: '', form: jsonData });
  };

  return (
    <>
      <ModalForm
        visible={visible}
        onClose={handleClose}
        formFields={fields}
        onFinish={onFinish}
        form={form}
        data={changePasswordStore.data}
        setData={changePasswordStore.setData}
      />
    </>
  );
};

export default ResetPassword;
